import Either from "data.either/lib/either"
import i18next from "i18next"
import validator from "validator"

export const recognizeEPCQrcode = (text) => {
	const common_not_recognized = i18next.t('not.recognized.common')
	console.debug(text)
	if (!text ) return Either.Left(common_not_recognized);
	const splitted = text.split('\n').map(line => line.replace('\r', ''));
	if (splitted[0].indexOf('BCD') < 0 ) return Either.Left(common_not_recognized);
	if(!splitted.length || (splitted.length !== 11 && splitted.length !== 12) || splitted[3] !== 'SCT' ) return Either.Left(common_not_recognized)
	const bic = splitted[4]
	const receipient = splitted[5]
	const iban = splitted[6]
	if( !iban || !validator.isIBAN(iban) ) return Either.Left(i18next.t('recognized.wrong.iban'))
	const strBetrag = splitted[7]
	const referenz = splitted[9]
	const verwendungszweck = splitted[10]
	const hinweis = splitted.length==12?splitted[11]:""
	if(strBetrag && !strBetrag.startsWith('EUR')) return Either.Left(i18next.t('recognized.wrong.betrag'))
	const betrag = validator.toFloat(strBetrag.slice(3))
	return Either.Right({ bic, receipient, iban, referenz, betrag, verwendungszweck, hinweis })
}